@if(!loading()) {
  @if (!isRowData()) {
    <button
      type="button"
      class="btn btn-secondary btn-icon"
      [disabled]="!isRowData()"
    >
      <i class="icon ic-table-20"></i>
    </button>
  } @else {
    <div ngbDropdown #dropdown="ngbDropdown" [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="column-filter">
      <button
        ngbDropdownToggle
        type="button"
        class="btn btn-secondary btn-icon"
        [class]="{ 'held': (dropdown.openChange) | async }"
        [disabled]="!isRowData()"
      >
        <i class="icon ic-table-20"></i>
      </button>

      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        @for (column of colDefs(); track $index) {
          @if(!column.suppressColumnsToolPanel) {
            @if (column.headerName && column?.field) {
              <div class="filter-option d-flex align-items-center">
                <i class="icon ic-drag-and-drop-20 mr-2"></i>
                <app-checkbox
                  [label]="column.headerName"
                  [value]="!column.hide"
                  [disabled]="disableSelection() && !column.hide"
                  (change)="onCheckboxChange(column)"
                ></app-checkbox>
              </div>
            } @else if(column.headerName && column?.children?.length) {
              <div class="filter-option d-flex align-items-center">
                <i class="icon ic-drag-and-drop-20 mr-2"></i>
                <app-checkbox
                  [label]="column.headerName"
                  [value]="!column.hide"
                  [disabled]="disableSelection() && !column.hide"
                  (change)="onGroupCheckboxChange(column)"
                ></app-checkbox>
              </div>

              @for(child of column?.children; track childIndex; let childIndex = $index) {
                <div class="filter-option d-flex ml-5">
                  <app-checkbox
                    [label]="child?.headerName || ''"
                    [value]="!$any(child)?.hide"
                    [disabled]="disableSelection() && !$any(child)?.hide"
                    (change)="onGroupChildCheckboxChange(column, childIndex)"
                  ></app-checkbox>
                </div>
              }
            }
          }
        }
      </div>
    </div>
  }
} @else {
  <button
    type="button"
    class="btn btn-secondary btn-icon"
    [disabled]="!!loading()"
  >
    <i class="icon ic-table-20"></i>
  </button>
}
